<template>
    <div>
        <v-navigation-drawer app dark clipped v-model="drawer" class="dddark">
            <MainMenu @option-clicked="drawer = false"/>
        </v-navigation-drawer>

        <v-app-bar app clipped-left height="75" color="dddark">
            <v-toolbar-title class="mr-6 pr-6">
                <img 
                    class="d-block"
                    :src="getLogo()" 
                    :width="isMobile ? 50 : 'auto'"
                    :height="isMobile ? 50 : 30"/>
            </v-toolbar-title>

            <ExpansionButton @click="drawer = !drawer"/>

            <v-divider vertical/>

            <UserAccount :isMobile="isMobile"/>
        </v-app-bar>
    </div>
</template>

<script>
import ExpansionButton from '@/components/appbar/ExpansionButton';
import MainMenu from '@/components/appbar/MainMenu';
import UserAccount from '@/components/appbar/UserAccount';

/**
 * AppBar component includes the main menu, the account information and controls
 * the behaviour of the collapsable menu.
 */
export default {
    name: 'AppBar',
    data: () => ({ 
        drawer: false,
        isMobile: false
    }),
    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize);
    },
    methods: {
        getLogo() {
            const { isDark } = this.$vuetify.theme;

            return isDark ?
                this.isMobile ? '/iconw.svg' : '/logow.svg' :
                this.isMobile ? '/icon.svg' : '/logo.svg';
        },
        onResize() {
            this.isMobile = window.innerWidth < 600;
        }
    },
    components: {
        ExpansionButton, MainMenu, UserAccount
    }
}
</script>